import TeamFilter from "components/timenotes/filters/team-filter"
import { ComponentProps } from "react"
import { useFormikContext } from "formik"

interface TeamFilterFieldProps extends ComponentProps<typeof TeamFilter> {
  membersKey: string
  groupsKey: string
  filters?: {
    projectId?: string
  }
}

const TeamFilterField = (props: TeamFilterFieldProps) => {
  const {
    membersKey,
    groupsKey,
    filters,
  } = props

  const formik = useFormikContext<any>()

  const memberHashIds: string[] = formik.values[membersKey] || []
  const groupHashIds: string[] = formik.values[groupsKey] || []

  return (
    <TeamFilter
      filters={filters}
      values={{
        memberHashIds: memberHashIds,
        groupHashIds: groupHashIds,
      }}
      onChange={(values) => {
        formik.setFieldValue(membersKey, values.memberHashIds)
        formik.setFieldValue(groupsKey, values.groupHashIds)
      }}
      {...props}
    />
  )
}

export default TeamFilterField